import React from "react";

export const EyeStroke = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        fillRule="evenodd"
        d="M17.25 18a.68.68 0 00.525-.225c.3-.3.3-.75 0-1.05L1.275.225c-.3-.3-.75-.3-1.05 0-.3.3-.3.75 0 1.05L3.45 4.5C2.1 5.625.9 7.05.075 8.625a1.04 1.04 0 000 .675c.15.3 3.3 6.45 8.925 6.45 1.575 0 3.075-.45 4.35-1.35l3.375 3.375c.15.15.3.225.525.225zM7.275 2.475c-.45.075-.675.45-.6.9.15.375.525.6.9.675.45-.075.975-.15 1.425-.15 4.05 0 6.75 4.05 7.425 5.25-.375.675-.825 1.275-1.35 1.875-.3.3-.225.75.075 1.05.075.075.3.15.45.15.225 0 .45-.15.6-.3.675-.825 1.275-1.65 1.725-2.55a1.04 1.04 0 000-.675c-.15-.3-3.3-6.45-8.925-6.45-.6 0-1.2.075-1.725.225zm.15 6.6c0 .375.15.75.45 1.05.45.375.975.45 1.5.3L7.5 8.55c0 .124-.023.225-.043.316a.965.965 0 00-.032.209zm3.075 2.55l1.8 1.725c-1.05.6-2.175.9-3.3.9-4.05 0-6.75-4.05-7.425-5.25.825-1.35 1.8-2.475 2.925-3.45l1.875 1.875c-.3.525-.45 1.125-.45 1.725.075.825.375 1.575.975 2.1a2.898 2.898 0 002.025.825c.525 0 1.125-.15 1.575-.45z"
        clipRule="evenodd"
      />
    </svg>
  );
};
